import { render, staticRenderFns } from "./adminStations.vue?vue&type=template&id=2480440f&scoped=true"
import script from "./adminStations.vue?vue&type=script&lang=js"
export * from "./adminStations.vue?vue&type=script&lang=js"
import style1 from "./adminStations.vue?vue&type=style&index=1&id=2480440f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2480440f",
  null
  
)

export default component.exports